import React from 'react';
import styles from './Title.css';

export default function Title() {
  return (
    <header>
      <div className={styles.heroImage}>
        <h3>Hey Arnold API!</h3>
      </div>
    </header>
  );
}

